export default __webpack_public_path__ + "static/blogicon-4e0faed474bf56ab4cc9b73a6c072d39.png";